const CustomProperty = () => {
  // scrollbar width 
  const div = document.createElement('div');
  div.style.overflow = 'scroll';
  div.style.visibility = 'hidden';
  document.body.appendChild(div);
  const scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
}

export default CustomProperty;